<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import EditRates from './contract_lcl/EditRates'
import Multiselect from 'vue-multiselect'

export default {
  name: 'EditFailTransitTime',
  props: {
    loadTable: { type: Boolean, default: false },
    transitTimeId: [String, Number],
  },
  components: { Multiselect },
  data() {
    return {
      loadingData: false,
      transitTimeIdC: this.transitTimeId,
      loadTableC: this.loadTable,
      generalData: [],
      origin: null,
      destiny: null,
      transitTime: null,
      carrier: null,
      destinationType: null,
      via: null,
      isTesting: false,
    }
  },
  computed: {},
  created() {
    // console.log(this.preLoad)
    this.loadData()
  },
    computed: {
    viaCp() {
      let data = this.destinationType[0]['id'] == 1? true:false
      if(!data) this.via[0] = null
      return data
    }
  },
  mounted() {},
  methods: {
    loadData() {
      this.loadingData = true
      if (!this.isTesting) {
        axiosGetPost('post', '/transit_times/getFailRow', {
          id: this.transitTimeIdC,
        }).then((response) => {
          console.log(response, 'response')
          let data = response.data
          this.generalData = data
          this.main_fecth()
          this.loadingData = false
          return response
        })
      } else {
        this.generalData = EditRates.data
        this.main_fecth()
        this.loadingData = false
      }
    },
    main_fecth() {
      this.carrier = this.generalData.transit_time['carrier']
      this.origin = this.generalData.transit_time['origin']
      this.destiny = this.generalData.transit_time['destiny']
      this.transitTime = this.generalData.transit_time['transit_time']
      this.destinationType = this.generalData.transit_time['destination_type']
      this.via = this.generalData.transit_time['via']
    },
    validateFields() {
      let bool = true
      const field_select = ['origin', 'destiny', 'carrier', 'destinationType']
      field_select.forEach(element => {
        if (!this[element][0]['id']) {
          this.$toastr.e('Attention. Select all fields ' + element)
          bool = false
        }
      });
      if (!this['transitTime'][0]) {
          this.$toastr.e('Attention. Select all field Transit Time')
          bool = false
        }
      if ((!this['via'][0]) && (this['destinationType'][0]['id'] == 1 )) {
          this.$toastr.e('Attention. Select all field via')
          bool = false
        }
      return bool
    },
    save() {
      if (!this.validateFields()) {
        return
      }
      //this.loadingData = true
      console.log(this.validateFields())
      axiosGetPost('post', '/transit_times/save', {
        id: this.transitTimeIdC,
        origin: this.origin[0],
        destiny: this.destiny[0],
        carrier: this.carrier[0],
        transitTime: this.transitTime[0],
        destinationType: this.destinationType[0],
        via: this.via[0],
      }).then((response) => {
        console.log(response)
        if (response.status) {
          axiosGetPost('put', '/transit_times/getFailRow', {
            id: this.transitTimeIdC,
          }).then((response) => {
            console.log(response, 'response')
            this.loadingData = false
            return response
          })
          this.$toastr.s('Success. Rate saved')
        } else {
          this.$toastr.e('Attention. Error')
        }
        this.loadingData = false
        this.$emit('update_table', ['fail', 'good'])
        return response
      })
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingData"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group">
        <div class="col-md-12 row">
          <div class="col-md-4">
            <label
              class="mb-1"
              v-bind:style="{ color: origin[1] ? 'forestgreen' : 'brown' }"
              for="default"
              >Origin:
            </label>
            <multiselect
              v-model="origin[0]"
              :options="generalData.harbors"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>
          <div class="col-md-4">
            <label
              class="mb-1"
              v-bind:style="{ color: destiny[1] ? 'forestgreen' : 'brown' }"
              for="default"
              >Destiny:
            </label>
            <multiselect
              v-model="destiny[0]"
              :options="generalData.harbors"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>
          <div class="col-md-4">
            <label
              class="mb-1 mt-0"
              v-bind:style="{ color: destinationType[1] ? 'forestgreen' : 'brown' }"
              for="default"
              >Destination Type:
            </label>
            <multiselect
              v-model="destinationType[0]"
              :options="generalData.destination_types"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 row">
          <div class="col-md-4">
            <label
              class="mb-1 mt-0"
              v-bind:style="{ color: carrier[1] ? 'forestgreen' : 'brown' }"
              for="default"
              >Carrier:
            </label>
            <multiselect
              v-model="carrier[0]"
              :options="generalData.carriers"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>

            <div class="col-md-4">
              <label
                class="mb-1 mt-0"
                for="default"
                v-bind:style="{ color: transitTime[1] ? 'forestgreen' : 'brown' }"
                >Transit Time:
              </label>
              <b-form-input
                :id="'name-'"
                v-model="transitTime[0]"
                value
                :placeholder="'Write value Transit Time'"
              ></b-form-input>
            </div>
            <div class="col-md-4">
              <label
                v-if="viaCp"
                class="mb-1 mt-0"
                for="default"
                v-bind:style="{ color: via[1] ? 'forestgreen' : 'brown' }"
                >Via:
              </label>
              <b-form-input
              v-if="viaCp"
                :id="'name-W/M'"
                v-model="via[0]"
                value
                :placeholder="'Write value Via'"
              ></b-form-input>
            </div>
          </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 row">
          <b-button variant="primary" class="form-control col-4" @click="save()"
            >Update</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>